import React, { useEffect,useState } from "react";
import { MyPortfolioReview } from "./Tab3Components/MyPortfolioReview";
import { MyActionable } from "./Tab3Components/MyActionable";
import { MyReports } from "./Tab3Components/MyReports";
import { MyGoalEvents } from "./Tab3Components/MyGoalEvents";
import { useSelector } from "react-redux";

export const Tab3 = ({setIsViewArchivedEvent,handleTabChange}) => {
  const roomId = new URLSearchParams(window.location.search).get("clientId");
  const [activeTab, setActiveTab] = useState("Goals");
  const { clientData } = useSelector((state) => state.client);


  return (
    <div>
      <div className="row mb-3 justify-content-center">
        <ul
          className="nav nav-tabs justify-content-center row"
          id="myTab1"
          role="tablist"
        >
          <li className="nav-item col-md-3 active text-center" role="presentation">
            <button
              className={`nav-link border-0 navclr mx-auto px-5 py-4 ${activeTab === "Goals" ? "active" : ""}`}
              id="Goals-tab"
              data-bs-toggle="tab"
              data-bs-target="#Goals-tab-pane"
              type="button"
              role="tab"
              aria-controls="Goals-tab-pane"
              aria-selected={activeTab === "Goals"}
              onClick={() => setActiveTab("Goals")}
            >
              <span className={`fs-21 mt-3 ${activeTab !== "Goals" && "clrgreen-black"}`}>My Goal Events</span>
            </button>
          </li>
          <li className="nav-item col-md-3 text-center" role="presentation">
            <button
              className={`nav-link border-0 navclr mx-auto px-5 py-4 ${activeTab === "Portfolio" ? "active" : ""}`}
              id="Portfolio-tab"
              data-bs-toggle="tab"
              data-bs-target="#Portfolio-tab-pane"
              type="button"
              role="tab"
              aria-controls="Portfolio-tab-pane"
              aria-selected={activeTab === "Portfolio"}
              onClick={() => setActiveTab("Portfolio")}
            >
              <span className={`fs-21 mt-3 ${activeTab !== "Portfolio" && "clrgreen-black"}`}>My Portfolio Reviews</span>
            </button>
          </li>
          <li className="nav-item col-md-3 text-center" role="presentation">
            <button
              className={`nav-link border-0 navclr mx-auto px-5 py-4 ${activeTab === "Action" ? "active" : ""}`}
              id="Action-tab"
              data-bs-toggle="tab"
              data-bs-target="#Action-tab-pane"
              type="button"
              role="tab"
              aria-controls="Action-tab-pane"
              aria-selected={activeTab === "Action"}
              onClick={() => setActiveTab("Action")}
            >
              <span className={`fs-21 mt-3 ${activeTab !== "Action" && "clrgreen-black"}`}>My Actionables</span>
            </button>
          </li>
          <li className="nav-item col-md-3 text-center" role="presentation">
            <button
              className={`nav-link border-0 navclr mx-auto px-5 py-4 ${activeTab === "Reports" ? "active" : ""}`}
              id="Reports-tab"
              data-bs-toggle="tab"
              data-bs-target="#Reports-tab-pane"
              type="button"
              role="tab"
              aria-controls="Reports-tab-pane"
              aria-selected={activeTab === "Reports"}
              onClick={() => setActiveTab("Reports")}
            >
              <span className={`fs-21 mt-3 ${activeTab !== "Reports" && "clrgreen-black"}`}>My Reports</span>
            </button>
          </li>
        </ul>
      </div>
      <div className="tab-content" id="myTabContent1">
        <div
          className={`tab-pane fade ${activeTab === "Goals" ? "show active" : ""}`}
          id="Goals-tab-pane"
          role="tabpanel"
          aria-labelledby="Goals-tab"
          tabIndex="0"
        >
          <MyGoalEvents roomId={roomId} setIsViewArchivedEvent={setIsViewArchivedEvent} handleTabChange={handleTabChange} />
        </div>
        <div
          className={`tab-pane fade ${activeTab === "Portfolio" ? "show active" : ""}`}
          id="Portfolio-tab-pane"
          role="tabpanel"
          aria-labelledby="Portfolio-tab"
          tabIndex="0"
        >
          <MyPortfolioReview roomId={roomId}  handleTabChange={handleTabChange}/>
        </div>
        <div
          className={`tab-pane fade ${activeTab === "Action" ? "show active" : ""}`}
          id="Action-tab-pane"
          role="tabpanel"
          aria-labelledby="Action-tab"
          tabIndex="0"
        >
          <MyActionable roomId={roomId}  clientData />
        </div>
        <div
          className={`tab-pane fade ${activeTab === "Reports" ? "show active" : ""}`}
          id="Reports-tab-pane"
          role="tabpanel"
          aria-labelledby="Reports-tab"
          tabIndex="0"
        >
          <MyReports roomId={roomId} />
        </div>
      </div>
    </div>
  );
};
